// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sjic","type":"styles_type__3STH4","choices":"styles_choices__2PfSq"};